<app-page-header title="Nemzetiségi önkormányzat"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <div class="h4 content-title text-center py-3">Bemutatkozás</div>
  <div class="p-5">
    <p>
      A községben 1994 óta működik német nemzetiségi önkormányzat, melynek fő
      tevékenysége a községben élő németség identitásának megőrzésére irányul.
      Ennek érdekében támogatja a faluban működő kultúrcsoportokat, rész vesz az
      egyház életében, évente szervez önálló rendezvényeket, táborokat a
      magyarországi svábok hagyományainak ápolására. Szorosan együttműködik a
      települési önkormányzattal, hogy célkitűzéseit a község lakóinak
      valamennyi korosztálya felé közvetítse. Céljainak eléréséhez a NNÖ az
      állami működési célú támogatáson túl pályáz a feladatalapú támogatásra.
      Ezen pályázat elbírálása minden év tavaszán történik. Pályázatokat
      nyújtunk be továbbá több belföldi és külföldi szervezethez is
      rendezvényeink támogatására, eszközbeszerzésre és költségtérítésre.
    </p>
    <p>
      A NNÖ tagjai: Emmer Edina – elnök<br />
      Ströcker Ignácné – elnökhelyettes<br />
      Aubéli Mónika – képviselő<br />
      Hartmann Károlyné – képviselő<br />
      Székelyi Balázs Zoltán – képviselő
    </p>
    <p>
      Elérhetőségeink: Cím: 2897 Dunaszentmiklós, Petőfi S. u. 52.<br />
      Telefon: +36-24-491-819<br />
      Mobil: +36-30-42-43-914<br />
      E-mail: nemzetiseg@dunaszentmiklos.hu
    </p>
  </div>
  <div class="h4 content-title text-center py-3">Dokumentumok</div>
  <div class="p-5">
    <app-accordion *ngFor="let type of documents" [title]="type.typeName">
      <ng-container *ngIf="type.years && type.years.length > 0">
        <app-accordion *ngFor="let year of type.years" [title]="year.year">
          <ng-container *ngIf="year.months && year.months.length > 0">
            <app-accordion
              *ngFor="let month of year.months"
              [title]="month.name"
            >
              <ul class="my-3">
                <li
                  *ngFor="let doc of month.docs"
                  (click)="
                    download(
                      doc.name,
                      type.folderName,
                      year.year,
                      month.number,
                      doc.id,
                      doc.ext,
                      doc.path
                    )
                  "
                >
                  <i class="fas fa-file-pdf mr-3"></i>{{ doc.name }}
                </li>
              </ul>
            </app-accordion>
          </ng-container>
          <ng-container *ngIf="!year.months || year.months.length === 0">
            <p>Nincs ide tartozó dokumentum</p>
          </ng-container>
        </app-accordion>
      </ng-container>
      <ng-container *ngIf="type.subCategories && type.subCategories.length > 0">
        <app-accordion
          *ngFor="let cat of type.subCategories"
          [title]="cat.name"
        >
          <ul class="my-3">
            <li
              *ngFor="let doc of cat.docs"
              (click)="
                download(doc.name, null, null, null, null, doc.ext, doc.path)
              "
            >
              <i
                [ngClass]="
                  doc.ext && doc.ext === '.xls'
                    ? 'fa-file-excel'
                    : doc.ext && (doc.ext === '.doc' || doc.ext === '.docx')
                    ? 'fa-file-word'
                    : 'fa-file-pdf'
                "
                class="fas mr-3"
              ></i
              >{{ doc.name }}
            </li>
          </ul>
        </app-accordion>
      </ng-container>
      <ng-container *ngIf="type.docs && type.docs.length > 0"></ng-container>
      <ul class="my-3">
        <li
          *ngFor="let doc of type.docs"
          (click)="
            download(doc.name, null, null, null, null, doc.ext, doc.path)
          "
        >
          <i
            [ngClass]="
              doc.ext && doc.ext === '.xls'
                ? 'fa-file-excel'
                : doc.ext && (doc.ext === '.doc' || doc.ext === '.docx')
                ? 'fa-file-word'
                : 'fa-file-pdf'
            "
            class="fas mr-3"
          ></i
          >{{ doc.name }}
        </li>
      </ul>
      <ng-container
        *ngIf="
          (!type.years || type.years.length === 0) &&
          (!type.subCategories || type.subCategories.length === 0) &&
          (!type.docs || type.docs.length === 0)
        "
      >
        <p>Nincs ehhez kapcsolódó dokumentum</p>
      </ng-container>
    </app-accordion>
  </div>
  <div class="h4 content-title text-center py-3">Pályázatok</div>
  <div class="p-2">
    <app-accordion title="Reginális német nemzetiségi tánctalálkozó">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;&nbsp;Reginális német
            nemzetiségi tánctalálkozó<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NKUL-KP-1-2023/2-000335<br />

            <strong>A támogatás összege</strong>: 600 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi Önkormányzat Regionális német nemzetiségi
            tánctalálkozóra adott be sikeres pályázatot. A rendezvényt 2023.
            június 10-11-én bonyolítottuk le.<br /><br />
            Fellépő tánccsoportok: Pilisvörösvári német nemzetiségi tánccsoport,
            Fliegende Zöpfe és a dunaszentmiklósi német nemzetiségi
            tánccsoport.<br /><br />
            Másnap Frühschopen keretében ünnepeltünk még a kultúrházban.<br /><br />
            Köszönjük a támogatást!<br /><br />
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717525387486.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717526973682.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717526973692.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717526973702.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717527084139.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img
                src="../../../assets/dokumentumok/uploads/2024/06/megvalosult_magyarorszag_kormanyanak_tamogatasaval_2023.jpg"
              />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion
      title="Hagyományőrző német nyelvű májusi litánia és dalostalálkozó"
    >
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;&nbsp; Hagyományőrző
            német nyelvű májusi litánia és dalostalálkozó<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NKUL-KP-1-2023/1-000722<br />

            <strong>A támogatás összege</strong>: 300 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            2023. május 14-én, vasárnap délután került sor községünkben a
            szokásos német nemzetiségi dalostalálkozóra. A rendezvény a
            Heimatskreis Niklo dalkör szervezésében valósult meg, anyagi
            hátterét a nemzetiségi önkormányzat biztosította a magyar kormány
            támogatásával.<br /><br />
            Idén – régi adósságunknak eleget téve – a két táti német nemzetiségi
            dalkört hívtuk meg a dalostalálkozóra. A templomban kezdtük a
            rendezvényt az immár hagyományos, német nyelvű májusi litániával,
            melyen a vendégkórusok is részt vettek. A litánia után a
            kultúrházban folytatódott a program. Szokás szerint elsőként a
            Kindertanzgruppe Niklo lépett a színpadra, a gyermekek ezúttal is
            mosolyt csaltak a közönség arcára. A vendégségbe érkezett dalkörök,
            tehát a táti asszonykórus és a táti férfikar a tőlük megszokott,
            rendkívül magas színvonalon adták elő műsorukat. Természetesen a
            dunaszentmiklósi felnőtt tánccsoport is megörvendeztetett bennünket
            parádés koreográfiáival. Helyi dalkörünk is igyekezett felérni a
            többi fellépő csoport magas nívójához, ebben ezúttal mindkét
            harmonikásunk, dr. Major Mária és Hartmann András is segítségünkre
            volt. A nyilvános program végeztével szerény vacsorára láttuk
            vendégül a fellépőket, melynek elköltése után felhangzottak a
            különböző vidám nóták az asztal körül.<br />
            Hálás köszönetet mondunk mindenkinek, aki a rendezvény szervezése
            és/vagy lebonyolítása során bármiben a segítségünkre volt!<br /><br />

            a Heimatskreis Niklo dalkör nevében:<br />
            Székelyi Balázs<br /><br />
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717525330964.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717525330949.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2024/06/1717525330936.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img
                src="../../../assets/dokumentumok/uploads/2024/06/megvalosult_magyarorszag_kormanyanak_tamogatasaval_2023.jpg"
              />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="CSSP-NEPTANC-MO-2021-0470">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;Német nemzetiségi
            koreográfia tanulása, laptop vásárlás<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;CSSP-NEPTANC-MO-2021-0470<br />

            <strong>A támogatás összege</strong>: 400 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi ÖnkormányzaT táncoktatásra adott be sikeres
            pályázatot, melynek keretében sikerült egy pilisvörösvári Wenczl
            József koreográfiát betanulni. A koreográfia címe: Szentiváni
            körtánc<br /><br />
            Oktató: Botzheim Nikoletta - Pilisvörösvári Német Nemzetiségi
            Táncegyüttes vezetője<br /><br />
            A pályázat keretében sikerült egy Asus laptopot is vásárolnunk, mely
            lehetővé teszi a próbák és fellépések sikeres lebonyolítását..<br /><br />
            <div class="row">
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2023/08/csoori_alap_rgb.jpg"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2023/08/1691388658523.jpg"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2023/08/1691388658512.jpg"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2023/08/1691310806124.jpg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="NKUL-KP-1-2022/1-000728">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;Sváb szavak,
            kifejezések gyűjteménye - Dunaszentmiklós (Sváb -magyar szótár)<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NKUL-KP-1-2022/1-000728<br />

            <strong>A támogatás összege</strong>: 300 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi Önkormányzat sváb szavak gyűjteményének kiadására
            adott be sikeres pályázatot, melynek keretében 200 példány
            készült.<br /><br />
            <div class="row">
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2023/07/1687634705034.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2023/07/1687634705041.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img src="../../../assets/imgs/korm_2022.jpg" />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="NEMZ-BER-20-0363">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;&nbsp;Nemzetiségi
            célú beruházási, felújítási és karbantartási tevékenységek 2020. évi
            költségvetési támogatása<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NEMZ-BER-20-0363<br />

            <strong>A támogatás összege</strong>: 1 475 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi Önkormányzat tájház kerítésének és a hátsó szoba
            vizesedése miatti felújítására adott be pályázatot 2020- ben, mely
            pozitív elbírálásban részesült.<br /><br />
            <div class="row">
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/12/20200603_182958.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/12/1667236964708.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/12/1667236964716.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/12/1667758770580.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/12/1667758941399.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img src="../../../assets/imgs/korm.jpg" />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="NBER-KP-1-2021/1-000448">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;&nbsp;Nemzetiségi
            célú beruházási, felújítási és karbantartási tevékenységek 2021. évi
            költségvetési támogatása<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NBER-KP-1-2021/1-000448<br />

            <strong>A támogatás összege</strong>: 500 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi Önkormányzat tájház nyílászáróinak felújítására
            adott be pályázatot 2021- ben, mely pozitív elbírálásban részesült.
            A bejárati ajtó, ablakok, padlás ajtó festése, felújítása
            megtörtént.<br /><br />
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/07/1687781373614.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/07/1687781373593.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <img
                class="scale-with-grid"
                src="../../../assets/dokumentumok/uploads/2023/07/1687781373604.jpg"
                alt="4.mell_jelenlegi_állapot"
                width="2592"
                height="1944"
              />
            </div>
          </div>
          <div class="col-12">
            <img src="../../../assets/imgs/korm_2021.jpg" />
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="NKER-KP-1-2021-1/000246">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás célja:</strong>&nbsp;&nbsp;&nbsp;Útmenti
            kőkeresztek felújítása 2021<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NKER-KP-1-2021-1/000246<br />

            <strong>A támogatás összege</strong>: 650 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi Önkormányzat 1 útmenti kőkereszt felújítására
            adott be pályázatot 2021- ben, mely pozitív elbírálásban részesült.
            A templomkertben található keresztet a szakember átcsiszolta, a
            feliratokat újra festette, valamint a kereszt impregnáló anyaggal
            történő bevonását is elvégezte.<br /><br />
            <div class="row">
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/05/1652713910735.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/05/1652713910742.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/05/1652713924744.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-3 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2022/05/1652713924751.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img src="../../../assets/imgs/regi_kereszt_2021.jpg" />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="NKUL-KP-1-2021/1-001450">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás címe:</strong>&nbsp;&nbsp;&nbsp; Német nyelvű
            litánia és dalostalálkozó 2021<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NKUL-KP-1-2021/1-001450<br />

            <strong>A támogatás összege</strong>: 200 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Német Nemzetiségi Önkormányzat Hagyományőrző német nyelvű litánia és
            dalostalákozó szervezésre adott be pályázatot, mely pozitív
            elbírálásban részesült.<br />
            A rendezvény 2021.október 24-én került megrendezésre.<br /><br />
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/11/received_309999210564403.jpeg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/11/1636292722090.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/11/1636292689427.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/11/ME_BGA.png"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/11/1636292689403.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/11/1636292689414.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img src="../../../assets/imgs/megv_korm_2021.jpg" />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>

    <app-accordion title="Útmenti kőkeresztek felújítása 2020">
      <div class="p-3">
        <div class="row">
          <div class="col-12">
            <strong>Kedvezményezett neve:</strong>&nbsp;&nbsp;Német Nemzetiségi
            Önkormányzat Dunaszentmiklós<br />

            <strong>A támogatás címe:</strong>&nbsp;&nbsp;&nbsp; Útmenti
            kőkeresztek felújítása 2020<br />

            <strong>Támogatás azonosító száma:</strong
            >&nbsp;NEMZ-N-20-0142<br />

            <strong>A támogatás összege</strong>: 300 000 Ft<br />

            <strong>Támogatás mértéke:</strong>&nbsp;100%<br /><br />

            Kivitelező: Ipach Róbert<br /><br />
            Német Nemzetiségi Önkormányzat 2 útmenti kőkereszt felújítására
            adott be pályázatot 2020- ban, mely pozitív elbírálásban
            részesült.<br /><br />
            A kereszteket (Öreg-hegyi és Neszmélyi utcai) a szakember
            átcsiszolta, a feliratokat újra festette, valamint a keresztek
            impregnáló anyaggal történő bevonását is elvégezte.<br /><br />
            A keresztek parkosítását társadalmi munkában kívánjuk elvégezni,
            amint a járványügyi helyzet megengedi.<br /><br />
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/04/1.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/04/2.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <img
                  class="scale-with-grid"
                  src="../../../assets/dokumentumok/uploads/2021/04/3.jpg"
                  alt="4.mell_jelenlegi_állapot"
                  width="2592"
                  height="1944"
                />
              </div>
            </div>
            <div class="col-12">
              <img src="../../../assets/imgs/korm.jpg" />
            </div>
          </div>
        </div>
      </div>
    </app-accordion>
  </div>
</div>
